import { memo, ReactNode, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';
import ROUTES from 'shared/constants/routes';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { useAppDispatch } from 'shared/helpers/useAppDispatch/useAppDispatch';
import { fetchState } from 'pages/RockPaperScissors/plays/model/services/fetchGameService';
import { ErrorBoundaryWrapper } from 'shared/components/ErrorBoundaryWrapper/errorBoundaryWrapper';
import { Navigation } from 'shared/components/Navigation';
import { useSelector } from 'react-redux';
import { getEnv } from 'store/appSelector';

declare global {
  interface Window {
    Pusher: unknown;
    Echo: Echo;
  }
}

type TLandingLayoutRoute = {
  isAuth: boolean;
  children?: ReactNode;
};

window.Pusher = Pusher;

const MainLayoutRoute = ({ isAuth, children }: TLandingLayoutRoute) => {
  const dispatch = useAppDispatch();
  const env = useSelector(getEnv); // 'telegram' | 'browser' | 'native_webview' | null
  console.log('MAIN_LAYOUT', isAuth);

  useEffect(() => {
    if (isAuth) {
      dispatch(fetchState());
    }
    document.body.classList.remove('body--games');
  }, [dispatch, isAuth]);

  if (!isAuth) {
    return (
      <Navigate
        to={env === 'telegram' ? ROUTES.LOGIN.ROUTE : ROUTES.WEB_LOGIN.ROUTE}
        replace
      />
    ); // TODO Изменить страницу навигации
  }

  return (
    <ErrorBoundaryWrapper>
      <div className="container">
        <div className="wrapper">
          <main>{children ?? <Outlet />}</main>
          <Navigation />
        </div>
      </div>
    </ErrorBoundaryWrapper>
  );
};

export default memo(MainLayoutRoute);
